export function filterBySearch(str: string, sentence: string) {
	let searchTokens = str.split(' ')
	return searchTokens.every(token => sentence.includes(token))
}

export function copyToClipboard(text: string) {
	void navigator.clipboard.writeText(text)
}

export function capitalizeAllWords(text: string, forceLowercase = false) {
	function toLowerCase(str: string) {
		return forceLowercase ? str.toLowerCase() : str
	}
	try {
		return text
			.split(' ')
			.map(word => word.charAt(0).toUpperCase() + toLowerCase(word.slice(1)))
			.join(' ')
	} catch (error) {
		return text
	}
}

export function cleanJsonBackticks(text: string) {
	return text.replace(/```json/g, '').replace(/```/g, '')
}

export function stripNullCharacters(text: string) {
	let result = ''
	for (let index = 0; index < text.length; index++) {
		const codeUnit = text.charCodeAt(index)
		if (codeUnit === 0) continue
		if (codeUnit >= 0xd800 && codeUnit <= 0xdbff) {
			const nextCodeUnit = text.charCodeAt(index + 1)
			if (nextCodeUnit >= 0xdc00 && nextCodeUnit <= 0xdfff) {
				result += text.slice(index, index + 2)
				index += 1
			} else {
				result += '\ufffd'
			}
			continue
		}
		if (codeUnit >= 0xdc00 && codeUnit <= 0xdfff) {
			result += '\ufffd'
			continue
		}
		result += text[index]
	}
	return result
}

export function stringHash(str: string) {
	let hash = 0

	for (let i = 0; i < str.length; i++) {
		let char = str.charCodeAt(i)
		hash = (hash << 5) - hash + char
		hash = hash & hash
	}

	return hash
}

export function removeAccents(text: string) {
	return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export function truncate(text: string, maxLength: number) {
	if (text.length <= maxLength) {
		return text
	}
	return text.slice(0, maxLength) + '...'
}

export function cleanTitleOfFilename(title: string) {
	let removeAll = [',', ';', ':', '"', '.']
	let result = title
	for (let remove of removeAll) {
		result = result.replaceAll(remove, '')
	}
	return result
		.replace(/[\r\n\t]/g, ' ')
		.replace(/\s+/g, ' ')
		.trim()
}
